import { useMemo } from "react";

import useConfig from "$src/core/hooks/use-config";
import useMenuQuery from "$src/core/queries/use-menu-query";

const useLogo = () => {
  const config = useConfig();

  const { data: menu } = useMenuQuery();

  return useMemo(() => {
    if (menu?.logo) {
      return { uri: menu.logo.url };
    }

    return { uri: config.logo.uri };
  }, [config, menu]);
};

export default useLogo;
